import React, { useMemo } from "react";
import { Box, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { useGetSecurities } from "../../queries/query-selectors/plaid-query-selectors";
import { AsyncContent } from "../../components";

export const MySecurities: React.FC = () => {
  const { data, isLoading } = useGetSecurities();

  const securities = useMemo(() => {
    return (data || []).map((d) => ({
      id: d.id,
      title: d.title,
      ticker: d.characteristic_data.find((char) => char.characteristic.name === "Ticker Symbol")?.value,
      assetClass: d.asset_class.name,
      units: Number(d.measure_data.find((md) => md.measure === "Quantity")?.amount) || 0,
      value: Number(d.measure_data.find((md) => md.measure === "Market Price")?.amount) || 0
    }));
  }, [data]);

  return (
    <Box flexGrow={1} sx={{ bgcolor: "white", borderRadius: "8px" }}>
      <AsyncContent loading={isLoading}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Asset Name</TableCell>
              <TableCell>Ticker</TableCell>
              <TableCell>Asset Class</TableCell>
              <TableCell>Total units</TableCell>
              <TableCell>Total value</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(securities || []).map((security) => (
              <TableRow key={security.id}>
                <TableCell>{security.title}</TableCell>
                <TableCell>{security.ticker}</TableCell>
                <TableCell>{security.assetClass}</TableCell>
                <TableCell>{security.units}</TableCell>
                <TableCell>${security.value}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </AsyncContent>
    </Box>
  );
};
